import { SOR } from "src/globalTypes";

interface BaseBreadcrumb {
  id: number;
  parentId: number | null;
  childId: number | null;
  defaultSOR: SOR;
}

export interface OverviewBreadcrumb extends BaseBreadcrumb {
  moduleId: number;
  type: "overview";
}

export interface DetailBreadcrumb extends BaseBreadcrumb {
  type: "detail" | "edit";
  rowKey: number;
  overviewId: number;
}

export type Breadcrumb = OverviewBreadcrumb | DetailBreadcrumb;

export type Breadcrumbs = Record<number, Breadcrumb>;

export type RecreateBreadcrumbParams = {
  detailId: number;
  overviewId: number;
  moduleId: number;
  rowKeyValue: number;
  detailType: "detail" | "edit";
  sor: SOR;
};

export interface BreadcrumbsProviderType {
  breadcrumbs: Breadcrumbs;
  receiveBreadcrumb(breadcrumb: Breadcrumb): void;
  toggleBreadcrumb(id: number): void;
  recreateBreadcrumbs(params: RecreateBreadcrumbParams): void;
}

// ---------------- TYPE GUARDS --------------------

export function isOverviewBreadcrum(
  breadcrumb: Breadcrumb
): breadcrumb is OverviewBreadcrumb {
  return breadcrumb.type === "overview";
}

export function isDetailBreadcrum(
  breadcrumb: Breadcrumb
): breadcrumb is DetailBreadcrumb {
  return breadcrumb.type === "detail" || breadcrumb.type === "edit";
}
